<div class="bookmark pull-right">
	<ul>
		<li *ngFor="let item of bookmarkItems">
			<a [routerLink]="item?.path" placement="top" ngbTooltip={{item?.title}}>
				<app-feather-icons [icon]="item?.icon"></app-feather-icons>
			</a>
		</li>
		<li>
			
			<a class="quick-nav-link quick-nav-calendar" routerLink="/dashboard/calendar" ngbTooltip="Calendar" placement="bottom" aria-label="Calendar">
				<i class="fa fa-calendar" aria-hidden="true"></i>
				<span>Calendar</span>
			</a>
			<a class="quick-nav-link quick-nav-dashboard" routerLink="/sample-page/dashboard" ngbTooltip="Dashboard" placement="bottom" aria-label="Dashboard">
				<i class="fa fa-home" aria-hidden="true"></i>
				<span>Dashboard</span>
			</a>
			<a *ngIf="isRouteAccessible('/dashboard/work-status')" class="quick-nav-link quick-nav-sales"
				routerLink="/dashboard/work-status" ngbTooltip="Access-Based - Sales Board" placement="bottom" aria-label="Sales Board">
				<i class="fa fa-line-chart" aria-hidden="true"></i>
				<span>Sales</span>
			</a>
			<a class="quick-nav-link quick-nav-time-tracking"
				routerLink="/users/time-tracking" ngbTooltip="Time Tracking" placement="bottom" aria-label="Time Tracking">
				<i class="fa-solid fa-clock" aria-hidden="true"></i>
				<span>Time Tracking</span>
			</a>
			<a *ngIf="isRouteAccessible('/dashboard/manager-status')" class="quick-nav-link quick-nav-manager"
				routerLink="/dashboard/manager-status" ngbTooltip="Access-Based - Manager Board" placement="bottom" aria-label="Manager Board">
				<i class="fa fa-users" aria-hidden="true"></i>
				<span>Manager</span>
			</a>
			<form class="form-inline search-form bookmark-form">
				<div class="form-group form-control-search" [class.open]="open">
					<input type="text" [(ngModel)]="text" [ngModelOptions]="{standalone: true}"
						(keyup)="searchTerm(text)" placeholder="Search..">
					<div class="Typeahead-menu" [class.is-open]="searchResult" *ngIf="menuItems?.length"
						id="boomark-search-outer">
						<div class="ProfileCard u-cf" *ngFor="let item of menuItems | slice:0:8">
							<div class="ProfileCard-avatar">
								<app-feather-icons [icon]="item.icon" class="header-search"></app-feather-icons>
							</div>
							<div class="ProfileCard-details">
								<div class="ProfileCard-realName">
									<a [routerLink]="item?.path" class="realname"
										(click)="removeFix()">{{item?.title}}</a>
									<span class="pull-right">
										<a href="javacript::void(0)" (click)="addToBookmark(item)">
											<i class="fa fa-star-o f-18 mt-1" [class.starred]="item.bookmark"></i>
										</a>
									</span>
								</div>
							</div>
						</div>
					</div>
					<div class="Typeahead-menu" [class.is-open]="searchResultEmpty">
						<div class="tt-dataset tt-dataset-0">
							<div class="EmptyMessage">
								Opps!! There are no result found.
							</div>
						</div>
					</div>
				</div>
			</form>
		</li>
	</ul>
</div>